"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDetails = void 0;
const React = require("react");
const InfoOutlined_1 = require("@mui/icons-material/InfoOutlined");
const material_1 = require("@mui/material");
const Currency_1 = require("../../../../../../components/base/atoms/Currency");
const TSalesOrderItemType_1 = require("../../../types/TSalesOrderItemType");
const useIsDeliveryItem_1 = require("../../../hooks/useIsDeliveryItem");
const useIsServiceItem_1 = require("../../../hooks/useIsServiceItem");
const useConfig_1 = require("../../../../../../hooks/useConfig");
const ProductEditSection_1 = require("../ProductEditSection");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ProductDetails");
/**
 * Shows details of a product including:
 *
 *  - Name
 *  - Quantity
 *  - Price
 *  - Selection details for built product
 */
const ProductDetails = ({ salesOrderItem, removeSalesOrderItemFromSalesOrder, isUpdatingCart, editable, updateProductQuantity, index, builderPromise, setSalesOrderItemBuiltDetails }) => {
    const { deliveryId, serviceId } = (0, useConfig_1.useConfig)();
    const isDeliveryItem = (0, useIsDeliveryItem_1.useIsDeliveryItem)(salesOrderItem, deliveryId);
    const isServiceItem = (0, useIsServiceItem_1.useIsServiceItem)(salesOrderItem, serviceId);
    return (React.createElement("div", { className: css("") },
        !isDeliveryItem && !isServiceItem && (React.createElement("div", { className: css("image"), style: { backgroundImage: `url("${salesOrderItem.image}")` } })),
        React.createElement("div", { className: css("details") },
            React.createElement("div", { className: css("details_summary") },
                React.createElement("div", { className: css("details_summary_title") },
                    salesOrderItem.title,
                    (isDeliveryItem || isServiceItem) && (React.createElement(material_1.Tooltip, { PopperProps: {
                            modifiers: [
                                {
                                    name: "offset",
                                    options: {
                                        offset: [0, -14]
                                    }
                                }
                            ]
                        }, title: isDeliveryItem
                            ? "Delivery fee is based on your location and other factors."
                            : "This 3% service fee (min: $1, max: $5) helps us operate our Zam app." },
                        React.createElement(material_1.IconButton, { size: "small" },
                            React.createElement(InfoOutlined_1.default, { fontSize: "small", color: "action" })))),
                    !isDeliveryItem && !isServiceItem && (React.createElement(React.Fragment, null,
                        ` (${salesOrderItem.quantity} X `,
                        React.createElement("label", null,
                            React.createElement(Currency_1.Currency, null, salesOrderItem.price)),
                        ")"))),
                React.createElement("div", { className: css("details_summary_cost") },
                    React.createElement("div", null,
                        React.createElement(Currency_1.Currency, null, salesOrderItem.cost)))),
            !isDeliveryItem && !isServiceItem && (React.createElement("div", { className: css("description") },
                salesOrderItem.type === TSalesOrderItemType_1.TSalesOrderItemType.Built &&
                    !!salesOrderItem.fullDescription && (React.createElement("small", null, salesOrderItem.fullDescription)),
                salesOrderItem.type === TSalesOrderItemType_1.TSalesOrderItemType.Fixed && editable && (React.createElement(ProductEditSection_1.ProductEditSection, { salesOrderItem: salesOrderItem, removeSalesOrderItemFromSalesOrder: removeSalesOrderItemFromSalesOrder, isUpdatingCart: isUpdatingCart, updateProductQuantity: updateProductQuantity, index: index, builderPromise: builderPromise, setSalesOrderItemBuiltDetails: setSalesOrderItemBuiltDetails })))))));
};
exports.ProductDetails = ProductDetails;
//# sourceMappingURL=index.js.map